import { render, staticRenderFns } from "./embedBlock.vue?vue&type=template&id=620bd16c&scoped=true"
import script from "./embedBlock.vue?vue&type=script&lang=js"
export * from "./embedBlock.vue?vue&type=script&lang=js"
import style0 from "./embedBlock.vue?vue&type=style&index=0&id=620bd16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620bd16c",
  null
  
)

export default component.exports